import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewChildren, HostListener } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as Chart from 'chart.js';
import { IssueService } from '../../../../services/issue.service';
import { ActivatedRoute, Route, Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issues-no-communication-chart',
    template: '<canvas id="basechart" #basechart *ngIf="data.length; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',
    styles: [':host { width: 100%; position: relative; display:block; }']
})
export class IssuesNoCommunicationChartComponent implements OnDestroy, AfterViewInit {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    consumerId: string;
    data: any[] = [];
    labels: any[] = [];
    pipe: DatePipe = new DatePipe('en_GB');
    clientId: number;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {

        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.issueService.issuePaygGetNoCommunication(this.clientId, this.siteId).then((result) => {
            this.data = [];
            this.labels = [];
            if (result.paygUnitsWithNoCommunicationLessThanOneDays > 0 || result.paygUnitsWithNoCommunicationInOneToThreeDays > 0 ||
                result.paygUnitsWithNoCommunicationInThreeToSevenDays > 0 || result.paygUnitsWithNoCommunicationInSevenDaysPlus > 0) {

                if (result.paygUnitsWithNoCommunicationLessThanOneDays > 0) {
                    this.data.push(result.paygUnitsWithNoCommunicationLessThanOneDays);
                    this.labels.push('Within 1 day');
                }

                if (result.paygUnitsWithNoCommunicationInOneToThreeDays > 0) {
                    this.data.push(result.paygUnitsWithNoCommunicationInOneToThreeDays);
                    this.labels.push('1 - 3 days');
                }

                if (result.paygUnitsWithNoCommunicationInThreeToSevenDays > 0) {
                    this.data.push(result.paygUnitsWithNoCommunicationInThreeToSevenDays);
                    this.labels.push('3 - 7 days');
                }

                if (result.paygUnitsWithNoCommunicationInSevenDaysPlus > 0) {
                    this.data.push(result.paygUnitsWithNoCommunicationInSevenDaysPlus);
                    this.labels.push('Over 7 days');
                }
                this.createChart();
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    private getChartConfig(): any {
        let config = {
            type: 'doughnut',
            options: {
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3'
                },
                legend: {
                    display: true
                },
                maintainAspectRatio: true,
                scales: {
                    xAxes: [{
                        display: false,
                    }],
                    yAxes: [{
                        display: false,
                    }]
                }
            }
        }

        return config;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.createChart();
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        datasets.push({
            label: 'PAYG',
            data: this.data,
            backgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            borderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointBorderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointBackgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointHoverBackgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointHoverBorderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b']
        });

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: {
                datasets: datasets,
                labels: this.labels
            },
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }


}
